import { render, staticRenderFns } from "./SchoolBusTerminal.vue?vue&type=template&id=1822f6c0&scoped=true"
import script from "./SchoolBusTerminal.vue?vue&type=script&lang=js"
export * from "./SchoolBusTerminal.vue?vue&type=script&lang=js"
import style0 from "./SchoolBusTerminal.vue?vue&type=style&index=0&id=1822f6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822f6c0",
  null
  
)

export default component.exports